import Flickity from "flickity";
require("flickity-sync");
require("flickity-fade");

class Carousel {
    constructor(passedElement) {
        this.elem = passedElement;
        this.carouselElem = this.elem.querySelector("[data-carousel]");
        this.carouselSyncElem = this.elem.querySelector("[data-sync-carousel]");

        this.carouselOptions = this.parseAttributes(this.carouselElem.getAttribute("data-attributes"));

        this.carouselLeft = this.elem.querySelector("[data-carousel-left]");
        this.carouselRight = this.elem.querySelector("[data-carousel-right]");
        this.dots = this.elem.querySelectorAll("[data-carousel-dot]");
    }

    init() {
        this.initCarousel();
    }

    initCarousel() {
        this.flkty = new Flickity(this.carouselElem, this.carouselOptions);

        if (this.carouselSyncElem) {
            const syncOptions = Object.assign({}, this.carouselOptions, {
                sync: this.carouselElem
            });
            this.flktySync = new Flickity(this.carouselSyncElem, syncOptions);
        }

        this.createListeners();
    }

    parseAttributes(attributeString) {
        try {
            return JSON.parse(attributeString);
        } catch (error) {
            return {};
        }
    }

    createListeners() {
        document.addEventListener("DOMContentLoaded", () => {
            if (this.carouselLeft) {
                this.carouselLeft.addEventListener("click", () => {
                    this.flkty.previous();
                    if (this.flktySync) {
                        this.flktySync.previous(); 
                    }
                });
            }

            if (this.carouselRight) {
                this.carouselRight.addEventListener("click", () => {
                    this.flkty.next(); 
                    if (this.flktySync) {
                        this.flktySync.next(); 
                    }
                });
            }

            if (this.dots.length) {
                this.dots[0].classList.add("is-active");

                this.dots.forEach((dot, index) => {
                    dot.addEventListener("click", () => {
                        this.dots.forEach((dot) => dot.classList.remove("is-active"));
                        dot.classList.add("is-active");
                        this.flkty.select(index); 

                    });
                });

                this.flkty.on("change", (index) => {
                    this.dots.forEach((dot) => dot.classList.remove("is-active"));
                    this.dots[index].classList.add("is-active");
                });
            }
        });
    }
}

export default Carousel;